import { render, staticRenderFns } from "./Movements.vue?vue&type=template&id=9c48fb0c&scoped=true&"
import script from "./Movements.vue?vue&type=script&lang=js&"
export * from "./Movements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c48fb0c",
  null
  
)

export default component.exports